<template>
  <div class="container">
    <el-card shadow="never" style="margin-bottom: 10px;">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'teachingPointList' }">教学点列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{ mode === 'add' ? '新增教学点' : '编辑教学点' }}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>

    <el-form ref="teachingPointForm" :model="formData" label-width="120px" label-position="right"
             :size="defaultFormItemSize" :rules="rules" @submit.native.prevent
    >
      <el-card shadow="never" style="margin-bottom: 10px;">
        <el-form-item label="教学点名称" prop="TeachingPoint.pointName">
          <el-input v-model="formData.TeachingPoint.pointName" placeholder="请输入教学点名称" :maxlength="200" show-word-limit />
        </el-form-item>
        <el-form-item label="位置" prop="TeachingPoint.location">
          <el-input v-model="formData.TeachingPoint.location" placeholder="请输入位置" :maxlength="500" show-word-limit />
        </el-form-item>
        <el-form-item label="简介" prop="TeachingPoint.pointDesc">
          <el-input v-model="formData.TeachingPoint.pointDesc" type="textarea" placeholder="请输入简介" :rows="4" :maxlength="500" show-word-limit />
        </el-form-item>
        <el-form-item label="经度" prop="TeachingPoint.longitude">
          <el-input-number v-model="formData.TeachingPoint.longitude" :min="-180" :max="180" :step="0.000001" :precision="6" placeholder="请输入经度" />
        </el-form-item>
        <el-form-item label="纬度" prop="TeachingPoint.latitude">
          <el-input-number v-model="formData.TeachingPoint.latitude" :min="-90" :max="90" :step="0.000001" :precision="6" placeholder="请输入纬度" />
        </el-form-item>
        <el-form-item label="图片" prop="TeachingPoint.imageUrl">
          <el-upload
            class="upload-demo" name="uploadFile" :headers="getUploadHeaders"
            :action="getUploadActionUrl('/admin/app/teachingPoint/upload')"
            :data="{fieldName: 'imageUrl', asImage: true}"
            :on-success="onImageUrlUploadSuccess"
            :on-remove="onImageUrlRemoveFile"
            :on-error="onUploadError"
            :show-file-list="true"
            :on-preview="handlePreview"
            :limit="teachingPointForm.imageUrl.impl.maxCount"
            :on-exceed="onUploadLimit"
            :file-list="teachingPointForm.imageUrl.impl.fileList"
            list-type="picture">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注" prop="TeachingPoint.remark">
          <el-input v-model="formData.TeachingPoint.remark" type="textarea" placeholder="请输入备注" :rows="4" :maxlength="500" show-word-limit />
        </el-form-item>
      </el-card>

      <div class="form-button-group">
        <el-button type="primary" :size="defaultFormItemSize" @click="onSaveClick()" :loading="isLoading">{{ mode === 'add' ? '新增' : '保存' }}</el-button>
        <el-button type="default" :size="defaultFormItemSize" @click="onCancelClick()">取消</el-button>
      </div>
    </el-form>
    <el-image-viewer v-if="imgViewerVisible" :on-close="closeImgViewer" :url-list="imgList" />
  </div>
</template>

<script>
import { TeachingPointController } from '@/api';
import { mapGetters } from 'vuex';
// eslint-disable-next-line no-unused-vars
import rules from '@/utils/validate.js';
import { UploadWidget } from '@/utils/widget.js';
import { uploadMixin } from '@/core/mixins';

export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },
  name: 'teachingPointForm',
  mixins: [uploadMixin],
  data () {
    return {
      formData: {
        TeachingPoint: {
          id: undefined,
          pointName: undefined,
          location: undefined,
          pointDesc: undefined,
          longitude: undefined,
          latitude: undefined,
          imageUrl: undefined,
          remark: undefined,
          isDatasourceInit: false
        }
      },
      teachingPointForm: {
        imageUrl: {
          impl: new UploadWidget(1)
        },
        isInit: false
      },
      rules: {
        'TeachingPoint.pointName': [
          { required: true, message: '请输入教学点名称', trigger: 'blur' },
          { min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
        ],
        'TeachingPoint.location': [
          { required: true, message: '请输入位置', trigger: 'blur' },
          { min: 1, max: 500, message: '长度在 1 到 500 个字符', trigger: 'blur' }
        ],
        'TeachingPoint.pointDesc': [
          { max: 500, message: '长度不能超过 500 个字符', trigger: 'blur' }
        ],
        'TeachingPoint.longitude': [
          { required: true, message: '请输入经度', trigger: 'blur' },
          { type: 'number', min: -180, max: 180, message: '经度范围在 -180 到 180 之间', trigger: 'blur' }
        ],
        'TeachingPoint.latitude': [
          { required: true, message: '请输入纬度', trigger: 'blur' },
          { type: 'number', min: -90, max: 90, message: '纬度范围在 -90 到 90 之间', trigger: 'blur' }
        ],
        'TeachingPoint.remark': [
          { max: 500, message: '长度不能超过 500 个字符', trigger: 'blur' }
        ]
      },
      imgViewerVisible: false,
      imgList: [],
      mode: 'add',
      isLoading: false
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      // 获取路由参数
      const query = this.$route.query;
      if (query.mode === 'add') {
        this.mode = 'add';
        this.resetFormData();
      } else if (query.id) {
        this.mode = 'edit';
        this.loadTeachingPointDetail(query.id);
      }
    },
    handlePreview (file) {
      this.imgViewerVisible = true
      this.imgList = []
      this.imgList.push(file.url)
    },
    closeImgViewer () {
      this.imgViewerVisible = false;
    },
    onImageUrlUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.uploadPath = response.data.uploadPath;
        file.url = URL.createObjectURL(file.raw);
        this.teachingPointForm.imageUrl.impl.onFileChange(file, fileList);
        this.formData.TeachingPoint.imageUrl = this.fileListToJson(this.teachingPointForm.imageUrl.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    onImageUrlRemoveFile (file, fileList) {
      this.teachingPointForm.imageUrl.impl.onFileChange(file, fileList);
      this.formData.TeachingPoint.imageUrl = this.fileListToJson(this.teachingPointForm.imageUrl.impl.fileList);
    },
    onUploadError (e, file, fileList) {
      this.$message.error('上传失败');
    },
    onUploadLimit (file, fileList) {
      this.$message.error(`最多只能上传${this.teachingPointForm.imageUrl.impl.maxCount}个文件`);
    },
    loadTeachingPointDetail (id) {
      this.isLoading = true;
      TeachingPointController.view(this, { id: id }).then(res => {
        this.formData.TeachingPoint = {...res.data, isDatasourceInit: true};
        let imageUrlDownloadParams = {
          id: this.formData.TeachingPoint.id,
          fieldName: 'imageUrl',
          asImage: true
        };
        this.teachingPointForm.imageUrl.impl.fileList = this.parseUploadData(this.formData.TeachingPoint.imageUrl, imageUrlDownloadParams);
      }).catch(e => {
        this.$message.error('加载教学点详情失败');
      }).finally(() => {
        this.isLoading = false;
      });
    },
    onSaveClick () {
      this.$refs.teachingPointForm.validate((valid) => {
        if (valid) {
          this.isLoading = true;
          let params = {
            teachingPointDto: {
              ...(this.mode === 'add' ? {
                pointName: this.formData.TeachingPoint.pointName,
                location: this.formData.TeachingPoint.location,
                pointDesc: this.formData.TeachingPoint.pointDesc,
                longitude: this.formData.TeachingPoint.longitude,
                latitude: this.formData.TeachingPoint.latitude,
                imageUrl: this.formData.TeachingPoint.imageUrl,
                remark: this.formData.TeachingPoint.remark
              } : this.formData.TeachingPoint)
            }
          };

          const savePromise = this.mode === 'add'
            ? TeachingPointController.add(this, params)
            : TeachingPointController.update(this, params);

          savePromise.then(res => {
            this.$message.success(this.mode === 'add' ? '新增成功' : '保存成功');
            this.onCancelClick();
          }).catch(e => {
            this.$message.error(this.mode === 'add' ? '新增失败' : '保存失败');
          }).finally(() => {
            this.isLoading = false;
          });
        } else {
          return false;
        }
      });
    },
    onCancelClick () {
      // 返回教学点列表页面
      this.$router.push({ name: 'teachingPointList' });
    },
    resetFormData () {
      this.formData = {
        TeachingPoint: {
          id: undefined,
          pointName: undefined,
          location: undefined,
          pointDesc: undefined,
          longitude: undefined,
          latitude: undefined,
          imageUrl: undefined,
          remark: undefined,
          isDatasourceInit: false
        }
      };
      this.teachingPointForm.imageUrl.impl.fileList = [];
    }
  }
}
</script>

<style scoped>
.container {
  padding: 20px;
}

.form-button-group {
  margin-top: 20px;
  text-align: center;
}
</style>
